import React from "react";
// import "./order.scss";
import { useTranslation } from "react-i18next";
import { SvgIcon } from "@/components/SvgIcon";
export interface IOrderInvalidProps {}

const OrderInvalid: React.FC<IOrderInvalidProps> = ({}) => {
  const { t } = useTranslation();
  return (
    <section className="order-invalid-wrapper">
      <SvgIcon icon="icon-wujieguo" />
      {t("当前订单不存在")}
    </section>
  );
};

export default OrderInvalid;
